import component from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-complaints/lni-retaliation-complaints.component.vue';
import module from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-complaints/lni-retaliation-complaints.module.js';

export default {
    component,
    module,
};